
import DialogAlert from "components/DialogAlert/DialogAlert";
import CustomSelect from "components/CustomSelect/CustomSelect";
import CloseButton from "components/CloseButton/CloseButton";
import CustomButton from "components/CustomButton/CustomButton";
import CustomTime from "components/CustomTimePicker/CustomTimePicker";
import Preloader from "components/Preloader/Preloader";
import { Container, Content, Footer } from "../DialogAlertUpdateDate/styles";
import { 
    Column,
    Row,
    TitleSection } from "components/styles";
import ErrorMessage from "components/ErrorMessage/ErrorMessage";
import { requestGetDurations, requestUpdateDuration } from "services/events/aboutEvents";
import { useEffect, useState } from "react";
import { diasSemana } from "components/CustomDatePicker/utils/helpers";
import { TIMEOUT_HIDDEN_TOAST_MESSAGE } from "components/ToastMessage/ToastMessage";
import useMainContext from "utils/context/useMainContext";

const ERROR_TEXTS = {
    INVALID_SCHEDULE_TIME: "Las horas son iguales o la hora de inicio es mayor a la de fin.",
    INVALID_CROSSING_SCHEDULE: "El horario seleccionado ya está ocupado por otro día."
};

const DialogDuration = ({
    show,
    toggleShow,
    dataEvent,
    setToastMessage
}) => {
    const mainContext = useMainContext();

    useEffect(() => {
        getDurations();
    }, [dataEvent]);

    const [durations, setDurations] = useState([]);
    const [date, setDate] = useState(null);
    const [loadingService, setLoadingService] = useState({
            isLoading: false,
            message: "",
    });
    const [durationSelected, setDurationSelected] = useState(0);
    const [newDaySelected, setNewDaySelected] = useState(0);
    const [hours, setHours] = useState({
        start: null,
        end: null
    });
    const [error, setError] = useState({
        text: ERROR_TEXTS.INVALID_SCHEDULE_TIME,
        value: false
    });

    const getDurations = async() =>{
        const response = await requestGetDurations(dataEvent.id);
        setDate(response.fechaFin);
        setDurations(response.duraciones);
    }

    const handlerSelectDuration = (value) => {
        setDurationSelected(value);
    }

    const handlerSelectNewDay = (value) => {
        setNewDaySelected(value);

        setError({
            ...error,
            value: false
        })
    }

    const handlerChangeTime = (type, value) => {
        setHours(prev => {
            return {
                ...prev,
                [type]: value
            };
        });

        setError({
            ...error,
            value: false
        })
    }

    const handlerChangeDuration = async () => {
        if(hours.start >= hours.end){
            setError({
                text: ERROR_TEXTS.INVALID_SCHEDULE_TIME,
                value: true
            });
            return;
        }
        const milisegundos = new Date(date).getTime();
        const request ={
            idDuracion: durationSelected,
            fecha: milisegundos,
            idDia: newDaySelected,
            horaInicio: hours.start,
            horaFin: hours.end
        }

        const loading={
            isLoading: true,
            message: "Cambiando día del evento..."
        }
        setLoadingService(loading)

        const response = await requestUpdateDuration(request);

        loading.isLoading = false;
        setLoadingService({...loading});

        if(!response){
			mainContext.setShowDialogUnexpectedError(true);
			return;
        }
        toggleShow(false);
        setToastMessage({
			hidden: false,
			message: "Se modificó el día del evento",
		});
		// Programando cierre automático del toast message
		setTimeout(() => {
			setToastMessage(prev => ({
				...prev,
				hidden: true,
			}));
		}, TIMEOUT_HIDDEN_TOAST_MESSAGE);
    }
    return(
        <DialogAlert 
            show={show}
            toggleShow={() => toggleShow()}
            onClose>
            <CloseButton onClick={() => toggleShow()}/>
            <Container>
                <Preloader
                    hidden={!loadingService.isLoading}
                    message={loadingService.message}
                />
                <TitleSection 
                    textAlign="center" 
                    fontWeight="900">Edición de día del evento</TitleSection>
                <Content>
                    <Column width="max-content">
                        <Row width="max-content">
                            <CustomSelect
                                label="Seleccione el día a modificar"
                                value={durationSelected}
                                onChange={handlerSelectDuration}
                                optionsProps={durations.map(item => {
                                    return {
                                        value: item.idDuracion,
                                        text: diasSemana[item.idDia]
                                    }
                                })}
                            />
                            <CustomSelect
                                label="Seleccione el nuevo día"
                                value={newDaySelected}
                                onChange={handlerSelectNewDay}
                                optionsProps={Object.entries(diasSemana).map(([key, value]) => {
                                    return {
                                        value: Number(key),
                                        text: value
                                    }
                                })}
                            />
                        </Row>
                    </Column>
                    <Column width="max-content">
                        <Row width="max-content">
                            <CustomTime 
                                label="Desde:"
                                caption="Desde:"
                                value={hours.start}
                                onChange={value => handlerChangeTime("start", value)}
                                error={error.value}
                                />
                            <CustomTime 
                                label="Hasta:"
                                caption="Hasta:"
                                value={hours.end}
                                onChange={value => handlerChangeTime("end", value)}
                                error={error.value}
                                />
                        </Row>
                        <ErrorMessage 
                            error={error.value}
                            text={error.text}/>
                    </Column>

                </Content>
                <Footer>
                    <CustomButton 
                        text="Sí, cambiar"
                        onClick={handlerChangeDuration}/>
                    <CustomButton 
                        variant="secondary"
                        text="No cancelar"
                        onClick={() => toggleShow(false)}/>
                </Footer>
            </Container>
        </DialogAlert>
    )
}

export default DialogDuration;